import React, {useState, useEffect, useRef} from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    TextField,
    MenuItem,
    Button,
    CircularProgress,
    Checkbox,
    FormControlLabel,
    Radio,
    Typography,
} from "@material-ui/core";
import { Close, Save, Edit, Send } from "@material-ui/icons/";
import { makeStyles } from "@material-ui/core/styles";
import moment from "moment";
import { COUNTRIES } from "./help/CountriesArray";
import axios from "axios";
import { formatMoney } from "../../lib/helperFuncs.jsx";

const useStyles = makeStyles((theme) => ({
    closeButton: {
        position: "absolute",
        right: theme.spacing(1),
        top: theme.spacing(1),
        cursor: "pointer",
    },
    textField: {
        width: "100%",
    },
    cgildrenField: {
        marginLeft: "20px",
    },
    buttonFirst: {
        margin: "16px 0 8px 0",
        backgroundColor: "blue",
    },
    buttonSecond: {
        margin: "16px 0 8px 20px",
        backgroundColor: "green",
    },
    loadingContainer: {
        position: "absolute",
        top: "50%",
        left: "50%",
    },
    allContainer: {
        position: "relative",
    },
    addQuest: {
        backgroundColor: "#80808040",
        margin: "16px 20px 8px 0",
        fontWeight: "800",
    },
    date: {
        fontWeight: "bold",
        marginRight: 8,
    },
    price: {
        marginBottom: 8,
    },
    personalItemsPrice: {
        display: "flex",
        alignItems: "center",
    },
    extraBedCheckbox: {
        margin: "25px 0 0 10px",
    },
    paymentOnline: {
        margin: "0 0 0 10px",
    },
    orderNumber: {
        color: "red",
        fontWeight: "bold",
        textDecoration: "underline",
    },
    typography: {
        width: "37vw",
        wordBreak: "break-word",
        fontWeight: "600",
        fontSize: "0.8vw",
    },
}));

const EditReservationPopup = ({
    open,
    onClose,
    loading,
    setLoading,
    reservation,
    reLoad,
    commentIsJson,
    commentObject,
}) => {
    const classes = useStyles();

    let adultGuests = [];
    let childGuests = [];
    let babiesGuests = [];
    let infantsGuests = [];

    if (commentIsJson) {
        const filteredAdults = commentObject.adults?.filter(adult =>
            !(adult.name?.includes('chief_guest'))
        );

        adultGuests = filteredAdults
            ?.map((adult, index) => {
                if (index % 4 === 0 && filteredAdults[index]?.value) {
                    const firstName = filteredAdults[index]?.value;
                    const lastName = filteredAdults[index + 1]?.value;
                    const nationality =
                        COUNTRIES[filteredAdults[index + 2]?.value];
                    const birthDate = moment(
                        filteredAdults[index + 3]?.value,
                        "DD.MM.YYYY",
                    ).format("YYYY-MM-DD");
                    const guestAdults = true;
                    return {
                        firstName,
                        lastName,
                        nationality,
                        birthDate,
                        guestAdults,
                    };
                }
            })
            ?.filter((guest) => guest !== undefined);
        childGuests = commentObject.childrens
            ?.map((children, index) => {
                if (index % 4 === 0) {
                    const firstName = commentObject.childrens[index]?.value;
                    const lastName = commentObject.childrens[index + 1]?.value;
                    const nationality =
                        COUNTRIES[commentObject.childrens[index + 2]?.value];
                    const birthDate = moment(
                        commentObject.childrens[index + 3]?.value,
                        "DD.MM.YYYY",
                    ).format("YYYY-MM-DD");
                    const guestAdults = false;
                    const guestBaby = false;
                    const guestInfant = false;
                    return {
                        firstName,
                        lastName,
                        nationality,
                        birthDate,
                        guestAdults,
                        guestBaby,
                        guestInfant,
                    };
                }
            })
            ?.filter((guest) => guest !== undefined);
        babiesGuests = commentObject.babies
            ?.map((babies, index) => {
                if (index % 4 === 0) {
                    const firstName = commentObject.babies[index]?.value;
                    const lastName = commentObject.babies[index + 1]?.value;
                    const nationality =
                        COUNTRIES[commentObject.babies[index + 2]?.value];
                    const birthDate = moment(
                        commentObject.babies[index + 3]?.value,
                        "DD.MM.YYYY",
                    ).format("YYYY-MM-DD");
                    const guestAdults = false;
                    const guestInfant = false;
                    const guestBaby = true;
                    return {
                        firstName,
                        lastName,
                        nationality,
                        birthDate,
                        guestAdults,
                        guestBaby,
                        guestInfant,
                    };
                }
            })
            ?.filter((guest) => guest !== undefined);
        infantsGuests = commentObject.infants
            ?.map((infants, index) => {
                if (index % 4 === 0) {
                    const firstName = commentObject.infants[index]?.value;
                    const lastName = commentObject.infants[index + 1]?.value;
                    const nationality =
                        COUNTRIES[commentObject.infants[index + 2]?.value];
                    const birthDate = moment(
                        commentObject.infants[index + 3]?.value,
                        "DD.MM.YYYY",
                    ).format("YYYY-MM-DD");
                    const guestAdults = false;
                    const guestBaby = false;
                    const guestInfant = true;
                    return {
                        firstName,
                        lastName,
                        nationality,
                        birthDate,
                        guestAdults,
                        guestBaby,
                        guestInfant
                    };
                }
            })
            ?.filter((guest) => guest !== undefined);
    } else {
        adultGuests = Array(reservation.adults)
            .fill()
            ?.map(() => {
                return {
                    firstName: "",
                    lastName: "",
                    nationality: "Russian Federation",
                    birthDate: "",
                    guestAdults: true,
                };
            });
        childGuests = Array(reservation.children || 0)
            .fill()
            ?.map(() => {
                return {
                    firstName: "",
                    lastName: "",
                    nationality: "Russian Federation",
                    birthDate: "",
                    guestAdults: false,
                };
            });
    }

    const guests = adultGuests
        ?.concat(childGuests)
        ?.concat(babiesGuests)
        ?.concat(infantsGuests)
        ?.filter((guest) => guest !== undefined);

    const [formData, setFormData] = useState({
        hotel_id: reservation.hotel.id,
        total: reservation.total,
        date_in:
            (reservation?.date_in &&
                moment(reservation.date_in).format("YYYY-MM-DD")) ||
            moment().format("YYYY-MM-DD"),
        date_out:
            (reservation?.date_out &&
                moment(reservation?.date_out).format("YYYY-MM-DD")) ||
            moment().add("1", "d").format("YYYY-MM-DD"),
        adults: reservation?.adults || 1,
        children: reservation?.children || 0,
        babies: reservation?.babies || 0,
        infant: reservation?.infant || 0,
        rate_id: reservation?.rate_id || "",
        room_type_id: reservation?.room_type_id || "",
        extra_bed: reservation?.extra_bed || false,
        craddle: reservation?.craddle,
        rooms: reservation?.room_quantity,
        email: reservation?.denormalized?.guest?.email,
        phone: reservation?.denormalized?.guest?.phone,
        comment_manager: reservation?.comment_manager,
        guests: guests || [
            {
                firstName: "",
                lastName: "",
                nationality: "Russian Federation",
                birthDate: "",
                guestAdults: true,
            },
        ],
    });

    const prevFormDataRef = useRef(formData);

    const [error, setError] = useState({});
    const [chiefGuest, setChiefGuest] = useState(
        commentIsJson ? getChiefGuest(commentObject) : 1,
    );

    const babyMaxAge = reservation?.hotel.data.baby_max_age;
    const childMaxAge = reservation?.hotel.data.child_max_age;
    const [rates, setRates] = useState([
        { id: reservation?.rate_id || 1, name: "Загрузка тарифов" },
    ]);
    const [roomTypes, setRoomTypes] = useState([
        { id: reservation?.room_type_id || 1, name: "Загрузка категорий" },
    ]);
    const [total, setTotal] = useState();
    const [paidOnline, setPaidOnline] = useState(null);
    const [maxPaid, setMaxPaid] = useState(null);
    const [totalCost, setTotalCost] = useState(null);
    const [pointsAmount, setPointsAmount] = useState(null);
    const [personalPrices, setPersonalPrices] = useState([]);
    const [personalPricesBuf, setPersonalPricesBuf] = useState([]);
    const [pricesDates, setPricesDates] = useState([]);
    const [openPersonalPrices, setOpenPersonalPrices] = useState(false);
    const [maySave, setMaySave] = useState(false);
    const [needRefresh, setNeedRefresh] = useState(false);
    const [canSaveOnlyName, setCanSaveOnlyName] = useState(false);
    const [promoName, setPromoName] = useState(null);
    const [cancelPromo, setCancelPromo] = useState(false);
    const [countAdults, setCountAdults] = useState(0);

    const [ignoreQuotasEnabled, setIgnoreQuotasEnabled] = useState(false);
    const [ignoreQuotas, setIgnoreQuotas] = useState(false);

    const [acceptPaymentOnline, setAcceptPaymentOnline] = useState(false);

    const [isChangeProcessed, setIsChangeProcessed] = useState(
        reservation?.is_change_processed,
    );

    const [newPoints, setNewPoints] = useState(null)

    const [beforeRateName, setBeforeRateName] = useState("");
    const [afterRateName, setAfterRateName] = useState("");

    const handleOpenPersonalPrices = () => {
        setOpenPersonalPrices(true);
    };

    const handleClosePersonalPrices = () => {
        setOpenPersonalPrices(false);
    };

    // если сняли галку Не учитывать отсутствие квоты, то заново проверять цены
    useEffect(() => {
        if (!ignoreQuotas) setMaySave(false);
    }, [ignoreQuotas]);

    //сохраняем персональные цены
    const handleSavePersonalPrices = async () => {
        setLoading(true);
        try {
            const response = await axios.post(
                "/manager/data/personal_prices/",
                {
                    prices: personalPrices,
                    reservations_id: reservation.id,
                },
            );
            handleSave();
            alert(response.data.message);
        } catch (err) {
            alert(err);
        }
        setLoading(false);
        setOpenPersonalPrices(false);
    };

    const handleChangePrice = (index, value) => {
        const newPersonalPrices = [...personalPrices];
        newPersonalPrices[index].price = value;
        setPersonalPrices(newPersonalPrices);
    };

    //получаем тарифы и категории из АваилДатес
    useEffect(() => {
        axios
            .get("/manager/data/reservations/hotel/" + reservation.hotel.id)
            .then((response) => {
                setRates(response.data.rates);
                setRoomTypes(response.data.room_types);
            });
    }, []);

    //добавляем поля с гостями при смене количества гостей
    useEffect(() => {
        const prevData = prevFormDataRef.current;

        const changedFields = {};
        if (prevData.adults !== formData.adults) changedFields.adults = true;
        if (prevData.children !== formData.children) changedFields.children = true;
        if (prevData.babies !== formData.babies) changedFields.babies = true;
        if (prevData.infant !== formData.infant) changedFields.infant = true;

        setFormData((prevFormData) => {
            const totalGuests =
                parseInt(prevFormData.adults) +
                parseInt(prevFormData.children) +
                parseInt(prevFormData.babies) +
                parseInt(prevFormData.infant);
            const newGuests = [...prevFormData.guests];
            const adultsCount = newGuests?.filter(
                (guest) => guest.guestAdults,
            ).length;

            if (newGuests.length < totalGuests) {
                let countGuests = 1;
                // Добавить новых гостей
                for (let i = newGuests.length; i < totalGuests; i++) {
                    newGuests.push({
                        firstName: "",
                        lastName: "",
                        nationality: "Russian Federation",
                        birthDate: "",
                        guestAdults:
                            adultsCount == formData.adults
                                ? false
                                : countGuests < prevFormData.adults,
                        guestBaby: changedFields?.babies || false,
                        guestInfant: changedFields?.infant || false,
                    });
                    countGuests++;
                }
            } else if (newGuests.length > totalGuests) {
                // Удалить лишних гостей
                if (formData.adults < adultsCount) {
                    const lastIndex = newGuests
                        .slice()
                        .reverse()
                        .findIndex((guest) => guest.guestAdults);
                    if (lastIndex !== -1) {
                        const indexToDelete = newGuests.length - 1 - lastIndex;
                        newGuests.splice(indexToDelete, 1);
                    }
                } else {
                    newGuests.splice(totalGuests);
                }
            }
            newGuests.sort((a, b) => b.guestAdults - a.guestAdults);

            return {
                ...prevFormData,
                guests: newGuests,
            };
        });

        prevFormDataRef.current = formData;
    }, [formData.adults, formData.children, formData.babies, formData.infant]);

    //получаем с БД персональные цены, или из брони
    useEffect(() => {
        if (openPersonalPrices) {
            setLoading(true);

            axios
                .post("/manager/data/personal_prices/show", {
                    reservations_id: reservation.id,
                    date_in: formData.date_in,
                    date_out: formData.date_out,
                })
                .then((response) => {
                    if (response.data.length > 0) {
                        setPersonalPricesBuf(response.data);
                    }
                    setLoading(false);
                });
        }
    }, [openPersonalPrices]);

    //синхронизируем персональные цены и выбранные даты
    useEffect(() => {
        const dateIn = moment(formData.date_in);
        const dateOut = moment(formData.date_out);
        const updatedPersonalPrices = [];

        for (let date = dateIn; date.isBefore(dateOut); date.add(1, "day")) {
            const dateString = date.format("YYYY-MM-DD");
            const dateForPrices = date.format("DD.MM.YYYY");
            const personalPrice = personalPricesBuf.find(
                (price) => price.date === dateString,
            );

            if (personalPrice) {
                updatedPersonalPrices.push(personalPrice);
            } else {
                const price = pricesDates[dateForPrices] || 0;
                updatedPersonalPrices.push({ date: dateString, price });
            }
        }

        setPersonalPrices(updatedPersonalPrices);
    }, [personalPricesBuf, formData.date_in, formData.date_out, pricesDates]);

    const handleInputChange = (event) => {
        const { name, value } = event.target;

        if (name === 'comment_manager') {
            setCanSaveOnlyName(false);
            setMaySave(true);
            setNeedRefresh(false);
        } else {
            setNeedRefresh(true);
            setMaySave(false);
            setCanSaveOnlyName(false);

            if (name != "rate_id") {
                setIgnoreQuotasEnabled(false);
                setIgnoreQuotas(false);
                setMaySave(false);
            }
        }

        setFormData((prevFormData) => ({
            ...prevFormData,
            [name]: value,
        }));
    };

    const handleGuestChange = (event, index) => {
        const { name, value } = event.target;

        if (!needRefresh) {
            setMaySave(true);
            setCanSaveOnlyName(true);
        } else {
            setMaySave(false);
            setCanSaveOnlyName(false);
        }

        setFormData((prevFormData) => {
            const newGuests = [...prevFormData.guests];
            newGuests[index] = {
                ...newGuests[index],
                [name]: value,
            };
            return {
                ...prevFormData,
                guests: newGuests,
            };
        });
    };

    const handleAddGuest = (guestAdults) => {
        setNeedRefresh(true);
        setMaySave(false);
        setCanSaveOnlyName(false);

        if (guestAdults)
            setFormData((data) => ({
                ...data,
                adults: parseInt(data.adults) + 1,
            }));
        else
            setFormData((data) => ({
                ...data,
                children: parseInt(data.children) + 1,
            }));
    };

    //сохраняем или обновляем форму изменения брони
    const handleSave = async (
        save = false,
        forceAcceptPaymentOnline = null,
    ) => {
        setLoading(true);
        const acceptPaymentOnlineFlag =
            forceAcceptPaymentOnline ?? acceptPaymentOnline;
        try {
            const comment = await getComment(
                formData,
                commentObject,
                chiefGuest,
                commentIsJson,
            );
            const response = await axios.post(
                "/manager/data/reservations/" + reservation.id,
                {
                    formData,
                    save,
                    comment,
                    chiefGuest,
                    ignoreQuotas,
                    onlyChangeName: canSaveOnlyName,
                    acceptPaymentOnlineFlag,
                    newPoints,
                    paidOnline
                },
            );
            if (save) {
                reLoad(reservation.id);
                alert(response.data.message);
                onClose();
                setTotal(null);
            } else {
                if (
                    formData.extra_bed == false &&
                    response.data.extra_bed == true
                ) {
                    setFormData((prev) => ({
                        ...prev,
                        extra_bed: true,
                    }));
                }

                if (
                    formData.craddle == false &&
                    response.data.craddle == true
                ) {
                    setFormData((prev) => ({
                        ...prev,
                        craddle: true,
                    }));
                }

                if (typeof response.data.chang === "number") {
                    setTotal(formatMoney(response.data.chang));
                    setPricesDates(response.data.prices_dates);
                    setPromoName(response.data.promo_name);
                    setCancelPromo(response.data.cancel_promo);
                    setTotalCost(response?.data?.totalCost);
                    setPointsAmount(response?.data?.points_amount);
                    setNewPoints(response?.data?.new_points ?? response?.data?.current_points);
                    setPaidOnline(response?.data?.paid_online);
                    setMaxPaid(response?.data?.paid_online);
                    setMaySave(true);
                } else if (typeof response.data.chang === "string") {
                    if (response.data?.notEnoughQuotas) {
                        setIgnoreQuotasEnabled(true);
                    } else {
                        setIgnoreQuotasEnabled(false);
                    }
                    setTotal(response.data.chang);
                    setPromoName(null);
                    setCancelPromo(false);
                    setMaySave(false);
                    setPaidOnline(null);
                }
            }
            setError({});
        } catch (err) {
            if (err?.response?.data != undefined)
                setError((e) => ({ ...err.response.data }));
            else console.error(err);
        }

        setCanSaveOnlyName(false);
        setNeedRefresh(false);
        setLoading(false);
    };

    const handleResendPaymentLink = () => {
        setLoading(true);
        axios
            .get("/manager/data/reservations/resend_payment/" + reservation.id)
            .then((response) => {
                alert(
                    "Новая ссылка на доплату будет создана и отправлена по СМС в течение 5 минут",
                );
                setLoading(false);
                setIsChangeProcessed(0);
                reLoad(reservation.id);
            })
            .catch((error) => {
                alert("Что то пошло не так!");
                setLoading(false);
                console.error(error);
            });
    };

    const onChangeCheckboxExtraBed = (event) => {
        const checked = event.target.checked;
        setFormData((prevFormData) => ({
            ...prevFormData,
            extra_bed: checked,
        }));
    };

    const onChangeCheckboxPaymentOnline = (event) => {
        const checked = Boolean(event.target.checked);
        setAcceptPaymentOnline(checked);

        handleSave(false, checked);
    };

    const onChangeCheckboxCradle = (event) => {
        const checked = event.target.checked;
        setFormData((prevFormData) => ({
            ...prevFormData,
            craddle: checked,
        }));
    };

    //подсчет количества взрослых гостей
    useEffect(() => {
        setCountAdults(
            formData.guests?.filter((guest) => guest.guestAdults).length,
        );
    }, [formData.guests]);

    // получаем сумму всех платежей
    const paymentsTotalAmount = reservation?.payments
        ?.filter((payment) => payment.status === "paid")
        .reduce(
            (accumulator, currentValue) => accumulator + currentValue.amount,
            0,
        );

    const handleChangePoints = (event) => {
        const value = +event.target.value;
        setNewPoints(pr => {
            if (pointsAmount < value || value < 0) {
                alert("Новое значение не может быть больше максимального или меньше нулю!")
                return pointsAmount
            } else {
                return value
            }
        });
    };

    const PaymentInput = () => {
        const inputRef = useRef(null);
        const [cursorPosition, setCursorPosition] = useState(0);

        const handleInputChange = (e) => {
            const value = e.target.value;
            const numericValue = value.replace(/[^\d.]/g, '');

            const numericPaidOnline = parseFloat(maxPaid);
            const inputNumber = parseFloat(numericValue) || 0;

            setCursorPosition(e.target.selectionStart);

            if (inputNumber > numericPaidOnline) {
                alert('Нельзя ввести сумму больше ' + formatMoney(numericPaidOnline));
                setPaidOnline(paidOnline);
            } else {
                setPaidOnline(numericValue);
            }
        };

        useEffect(() => {
            if (inputRef.current) {
                inputRef.current.focus();
                const length = inputRef.current.value.length;
                inputRef.current.setSelectionRange(length, length);            }
        }, [paidOnline, cursorPosition]);

        const handleBlur = () => {
            const numericValue = parseFloat(paidOnline) || 0;
            const numericPaidOnline = parseFloat(maxPaid);

            if (numericValue > numericPaidOnline) {
                setPaidOnline(numericPaidOnline);
            } else {
                setPaidOnline(numericValue);
            }

            if (inputRef.current) {
                inputRef.current.blur();
            }
        };

        return (
            <input
                ref={inputRef}
                type="text"
                value={paidOnline}
                onChange={handleInputChange}
                onBlur={handleBlur}
                style={{
                    fontWeight: "bold",
                    fontSize: "18px",
                    color: "#3f51b5",
                    border: "1px solid #3f51b5",
                    borderRadius: "4px",
                    padding: "8px 12px",
                    outline: "none",
                    width: "200px"
                }}
            />
        );
    };

    return (
        <Dialog maxWidth="xl" open={open} onClose={onClose}>
            <DialogTitle>
                Изменение брони{" "}
                <span className={classes.orderNumber}>
                    № {reservation.number}
                </span>
                <Close className={classes.closeButton} onClick={onClose} />
                {promoName !== null && (
                    <h2>
                        Промокод:{" "}
                        <span style={{ color: "black" }}>{promoName}</span>{" "}
                        {cancelPromo && (
                            <span style={{ color: "red" }}>будет отменен!</span>
                        )}
                    </h2>
                )}
            </DialogTitle>
            <DialogContent>
                <div className={classes.allContainer}>
                    {loading && (
                        <CircularProgress
                            className={classes.loadingContainer}
                        />
                    )}
                    <TextField
                        required
                        margin="normal"
                        size="small"
                        label="Дата заезда"
                        type="date"
                        name="date_in"
                        value={formData.date_in}
                        onChange={handleInputChange}
                        disabled={loading}
                        InputLabelProps={{
                            shrink: true,
                        }}
                        error={!!error.date_in}
                        helperText={error.date_in && error.date_in[0]}
                    />

                    <TextField
                        required
                        className={classes.cgildrenField}
                        margin="normal"
                        size="small"
                        label="Дата выезда"
                        type="date"
                        name="date_out"
                        value={formData.date_out}
                        onChange={handleInputChange}
                        disabled={loading}
                        InputLabelProps={{
                            shrink: true,
                        }}
                        error={!!error.date_out}
                        helperText={error.date_out && error.date_out[0]}
                    />

                    {/*<TextField*/}
                    {/*    required*/}
                    {/*    className={classes.cgildrenField}*/}
                    {/*    margin="normal"*/}
                    {/*    size="small"*/}
                    {/*    label="Изменение email"*/}
                    {/*    type="email"*/}
                    {/*    name="email"*/}
                    {/*    value={formData.email}*/}
                    {/*    onChange={handleInputChange}*/}
                    {/*    disabled={loading}*/}
                    {/*    error={!!error.email}*/}
                    {/*    helperText={error.email && error.email[0]}*/}
                    {/*/>*/}

                    {/*<TextField*/}
                    {/*    required*/}
                    {/*    className={classes.cgildrenField}*/}
                    {/*    margin="normal"*/}
                    {/*    size="small"*/}
                    {/*    label="Изменение телефона"*/}
                    {/*    type="tel"*/}
                    {/*    name="phone"*/}
                    {/*    value={formData.phone}*/}
                    {/*    onChange={handleInputChange}*/}
                    {/*    disabled={loading}*/}
                    {/*    error={!!error.phone}*/}
                    {/*    helperText={error.phone && error.phone[0]}*/}
                    {/*/>*/}

                    <br />
                    <TextField
                        required
                        margin="normal"
                        size="small"
                        label="Кол\во взрослых"
                        type="number"
                        name="adults"
                        value={formData.adults}
                        onChange={handleInputChange}
                        disabled={loading}
                        error={!!error.adults}
                        helperText={error.adults && error.adults[0]}
                    />
                    <TextField
                        className={classes.cgildrenField}
                        margin="normal"
                        size="small"
                        label="Кол\во детей"
                        type="number"
                        name="children"
                        value={formData.children}
                        onChange={handleInputChange}
                        disabled={loading}
                    />
                    <TextField
                        className={classes.cgildrenField}
                        margin="normal"
                        size="small"
                        label="Кол\во младенцев"
                        type="number"
                        name="babies"
                        value={formData.babies}
                        onChange={handleInputChange}
                        disabled={loading}
                    />
                    <TextField
                        className={classes.cgildrenField}
                        margin="normal"
                        size="small"
                        label="Кол\во инфантов"
                        type="number"
                        name="infant"
                        value={formData.infant}
                        onChange={handleInputChange}
                        disabled={loading}
                    />
                    <br/>
                    <FormControlLabel
                        className={classes.extraBedCheckbox}
                        control={
                            <Checkbox
                                checked={Boolean(formData?.extra_bed)}
                                onChange={onChangeCheckboxExtraBed}
                                name="extra_bed"
                                color="primary"
                                disabled={loading}
                            />
                        }
                        label="Доп. место"
                    />
                    <FormControlLabel
                        className={classes.extraBedCheckbox}
                        control={
                            <Checkbox
                                checked={Boolean(formData?.craddle)}
                                onChange={onChangeCheckboxCradle}
                                name="craddle"
                                color="primary"
                                disabled={loading}
                            />
                        }
                        label="Колыбель"
                    />
                    <br />
                    <TextField
                        required
                        className={classes.textField}
                        margin="normal"
                        size="small"
                        select
                        label="Тариф"
                        name="rate_id"
                        value={formData.rate_id}
                        onChange={handleInputChange}
                        disabled={loading}
                        error={!!error.rate_id}
                        helperText={error.rate_id && error.rate_id[0]}
                    >
                        {rates?.map((rate) => (
                            <MenuItem key={rate.id} value={rate.id}>
                                {rate.id === formData.rate_id
                                    ? beforeRateName + rate.name + afterRateName
                                    : rate.name}
                            </MenuItem>
                        ))}
                    </TextField>
                    <br />
                    <TextField
                        required
                        className={classes.textField}
                        margin="normal"
                        size="small"
                        select
                        label="Категория номера"
                        name="room_type_id"
                        value={formData.room_type_id}
                        onChange={handleInputChange}
                        disabled={loading}
                        error={!!error.room_type_id}
                        helperText={error.room_type_id && error.room_type_id[0]}
                    >
                        {roomTypes?.map((roomType) => (
                            <MenuItem key={roomType.id} value={roomType.id}>
                                {roomType.name}
                            </MenuItem>
                        ))}
                    </TextField>
                    <br />
                    {!commentIsJson && (
                        <Typography
                            variant="body2"
                            component="h3"
                            className={classes.typography}
                        >
                            {reservation.comment}
                        </Typography>
                    )}
                    {formData.guests?.map((guest, index) => (
                        <div key={index}>
                            <h3>
                                Данные{" "}
                                {guest.guestAdults
                                    ? "взрослого гостя " + (parseInt(index) + 1)
                                    : "детского гостя " +
                                      (parseInt(index) + 1 - countAdults)}
                                {index + 1 === chiefGuest && (
                                    <p
                                        style={{
                                            color: "green",
                                            display: "inline",
                                        }}
                                    >
                                        {" "}
                                        (Главный гость)
                                    </p>
                                )}
                            </h3>
                            <TextField
                                required
                                margin="normal"
                                size="small"
                                label="Имя"
                                name="firstName"
                                value={guest.firstName}
                                onChange={(event) =>
                                    handleGuestChange(event, index)
                                }
                                disabled={loading}
                                error={!!error[`guests.${index}.firstName`]}
                                helperText={
                                    error[`guests.${index}.firstName`] &&
                                    error[`guests.${index}.firstName`][0]
                                }
                            />
                            <TextField
                                required
                                className={classes.cgildrenField}
                                margin="normal"
                                size="small"
                                label="Фамилия"
                                name="lastName"
                                value={guest.lastName}
                                onChange={(event) =>
                                    handleGuestChange(event, index)
                                }
                                disabled={loading}
                                error={!!error[`guests.${index}.lastName`]}
                                helperText={
                                    error[`guests.${index}.lastName`] &&
                                    error[`guests.${index}.lastName`][0]
                                }
                            />
                            <TextField
                                required
                                className={classes.cgildrenField}
                                margin="normal"
                                select
                                size="small"
                                label="Гражданство"
                                name="nationality"
                                value={guest.nationality || COUNTRIES[0]}
                                onChange={(event) =>
                                    handleGuestChange(event, index)
                                }
                                disabled={loading}
                                error={!!error[`guests.${index}.nationality`]}
                                helperText={
                                    error[`guests.${index}.nationality`] &&
                                    error[`guests.${index}.nationality`][0]
                                }
                            >
                                {COUNTRIES.map((country, idx) => (
                                    <MenuItem key={idx} value={country}>
                                        {country}
                                    </MenuItem>
                                ))}
                            </TextField>
                            <TextField
                                required
                                className={classes.cgildrenField}
                                margin="normal"
                                size="small"
                                label="Дата рождения"
                                type="date"
                                name="birthDate"
                                value={guest.birthDate}
                                onChange={(event) =>
                                    handleGuestChange(event, index)
                                }
                                disabled={loading}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                error={!!error[`guests.${index}.birthDate`]}
                                helperText={
                                    error[`guests.${index}.birthDate`] &&
                                    error[`guests.${index}.birthDate`][0]
                                }
                            />
                            {guest.guestAdults && (
                                <FormControlLabel
                                    control={
                                        <Radio
                                            checked={index + 1 == chiefGuest}
                                            onChange={() =>
                                                setChiefGuest(index + 1)
                                            }
                                            disabled={loading}
                                        />
                                    }
                                />
                            )}
                        </div>
                    ))}
                    <br />
                    <Button
                        className={classes.addQuest}
                        disabled={loading}
                        onClick={() => handleAddGuest(true)}
                    >
                        Добавить взрослого гостя
                    </Button>
                    <Button
                        className={classes.addQuest}
                        disabled={loading}
                        onClick={() => handleAddGuest(false)}
                    >
                        Добавить детского гостя
                    </Button>
                    <br />
                    <TextField
                        margin="normal"
                        fullWidth
                        label="Комментарий"
                        multiline
                        minRows={3}
                        name="comment_manager"
                        value={formData.comment_manager || ""}
                        onChange={handleInputChange}
                        disabled={loading}
                        InputProps={{ disableUnderline: true }}
                    />
                    <br />
                    <hr />
                    <Button
                        className={classes.buttonThird}
                        variant="contained"
                        color={"primary"}
                        onClick={() => handleOpenPersonalPrices()}
                        disabled={loading || !maySave}
                    >
                        Персональные цены
                    </Button>

                    {maySave && (
                        <FormControlLabel
                            className={classes.paymentOnline}
                            control={
                                <Checkbox
                                    checked={Boolean(acceptPaymentOnline)}
                                    onChange={onChangeCheckboxPaymentOnline}
                                    name="accept_payment_online"
                                    color="primary"
                                    disabled={loading}
                                />
                            }
                            label="Принять оплату онлайн"
                        />
                    )}

                    {ignoreQuotasEnabled && (
                        <FormControlLabel
                            className={classes.extraBedCheckbox}
                            control={
                                <Checkbox
                                    checked={ignoreQuotas}
                                    onChange={() =>
                                        setIgnoreQuotas(
                                            (previousState) => !previousState,
                                        )
                                    }
                                    name="ignore_quotas"
                                    color="primary"
                                    disabled={loading}
                                />
                            }
                            label="Не учитывать отсутствие квоты"
                        />
                    )}

                    <Dialog
                        open={openPersonalPrices}
                        onClose={handleClosePersonalPrices}
                    >
                        <DialogTitle>Персональные цены</DialogTitle>
                        <DialogContent>
                            {personalPrices.length > 0 &&
                                personalPrices?.map((item, index) => (
                                    <div
                                        className={classes.personalItemsPrice}
                                        key={index}
                                    >
                                        <span className={classes.date}>
                                            {item.date}
                                        </span>
                                        <TextField
                                            className={classes.price}
                                            label="Цена"
                                            type="number"
                                            value={item.price}
                                            onChange={(e) =>
                                                handleChangePrice(
                                                    index,
                                                    e.target.value,
                                                )
                                            }
                                            disabled={loading}
                                        />
                                    </div>
                                ))}
                            <Button
                                disabled={loading}
                                onClick={handleClosePersonalPrices}
                            >
                                Отмена
                            </Button>
                            <Button
                                disabled={loading}
                                onClick={handleSavePersonalPrices}
                            >
                                Сохранить
                            </Button>
                        </DialogContent>
                    </Dialog>
                    <br />
                    <br />
                    {totalCost && totalCost > 0 && (
                        <div
                            style={{
                                fontWeight: "bold",
                                fontSize: "18px",
                                color: "#3f51b5",
                            }}
                        >
                            {"Сумма брони: " + formatMoney(totalCost)}
                        </div>
                    )}

                    {pointsAmount &&
                    pointsAmount != null &&
                    pointsAmount >= 0 ? (
                        <div
                            style={{
                                fontWeight: "bold",
                                fontSize: "18px",
                                color: "#3f51b5",
                            }}
                        >
                            Укажите скидку
                            <span style={{
                                fontWeight: "400",
                                fontSize: "15px",
                                color: "black",
                            }}> Максимальная скидка за баллы: {pointsAmount}</span>
                            <span style={{
                                fontWeight: "400",
                                fontSize: "15px",
                                color: "black",
                            }}> Текущая скидка: </span>
                            <input style={{
                                border: 'none',
                                fontSize: "16px",
                                outline: 'none',
                                borderBottom: 'double',
                                width: '80px'
                            }} type="number" onChange={handleChangePoints} value={newPoints}/>
                            <span style={{
                                fontWeight: "400",
                                fontSize: "15px",
                                color: "black",
                            }}> баллов</span>
                        </div>
                    ) : (
                        <div></div>
                    )}

                    <div
                        style={{
                            fontWeight: "bold",
                            fontSize: "18px",
                            color: "#3f51b5",
                        }}
                    >
                        {canSaveOnlyName
                            ? "Можно сохранить новые данные гостя"
                            : "Итого к доплате: " +
                              (total ?? "Обновите данные")}
                    </div>

                    {paidOnline !== null && (
                        <div
                            style={{
                                fontWeight: "bold",
                                fontSize: "18px",
                                color: "#3f51b5",
                            }}
                        >
                            {"Оплатить онлайн: "}
                            <PaymentInput/>
                        </div>
                    )}

                    <Button
                        className={classes.buttonFirst}
                        variant="contained"
                        color={"secondary"}
                        startIcon={<Edit />}
                        onClick={() => handleSave(false)}
                        disabled={loading}
                    >
                        Проверить наличие мест
                    </Button>
                    <Button
                        className={classes.buttonSecond}
                        variant="contained"
                        color={"primary"}
                        startIcon={<Save />}
                        onClick={() => handleSave(true)}
                        disabled={loading || !maySave}
                    >
                        Сохранить
                    </Button>
                    {reservation?.payment_method?.id == 2 &&
                        reservation.total > paymentsTotalAmount &&
                        isChangeProcessed == 1 && (
                            <Button
                                className={classes.buttonSecond}
                                variant="contained"
                                color={"secondary"}
                                startIcon={<Send />}
                                onClick={() => handleResendPaymentLink()}
                                disabled={loading}
                            >
                                Повторно отправить ссылку на доплату
                            </Button>
                        )}
                </div>
            </DialogContent>
        </Dialog>
    );
};

export default EditReservationPopup;

// Helper function
const getComment = async (data, commentObject, chiefGuest, commentIsJson) => {
    let uniQid = "";
    if (!commentIsJson) {
        uniQid = await fetchUniqId();
        commentObject = null;
    }

    const adults = data.guests
        ?.filter((guest) => guest.guestAdults)
        .reduce((acc, guest, index) => {
            const adultIndex = index + 1;
            const adultPrefix =
                commentObject !== null && commentObject?.adults !== null
                    ? commentObject.adults
                          .find((adult) =>
                              adult.name?.includes(`[1][firstname]`),
                          )
                          .name.match(/^(.+)\[1\]/)[1]
                    : `adult_guests[${uniQid}]`;
            if (index === 0) {
                acc.push({
                    name:
                        commentObject !== null
                            ? commentObject?.adults?.find((adult) =>
                                  adult.name?.includes("[chief_guest]"),
                              )?.name
                            : `${adultPrefix}[chief_guest]`,
                    value: chiefGuest,
                });
            }
            acc.push(
                {
                    name: `${adultPrefix}[${adultIndex}][firstname]`,
                    value: guest.firstName,
                },
                {
                    name: `${adultPrefix}[${adultIndex}][lastname]`,
                    value: guest.lastName,
                },
                {
                    name: `${adultPrefix}[${adultIndex}][country_id]`,
                    value: getIndexCountries(guest.nationality),
                },
                {
                    name: `${adultPrefix}[${adultIndex}][birth]`,
                    value: moment(guest.birthDate).format("DD.MM.YYYY"),
                },
            );
            return acc;
        }, []);

    const prefixOld = commentObject?.adults?.map((item) => {
        const match = item.name.match(/\[(.*?)\]\[chief_guest\]/);
        return match ? match[1] : null;
    });

    if (prefixOld !== undefined) {
        uniQid = prefixOld[0];
    }

    const childrens = data.guests
        ?.filter((guest) => !guest.guestAdults && !guest.guestBaby && !guest.guestInfant)
        .reduce((acc, guest, index) => {
            const childIndex = index + 1;

            const childPrefix =
                commentObject !== null &&
                commentObject?.childrens !== null &&
                commentObject?.childrens?.length > 0
                    ? commentObject.childrens
                          .find((child) =>
                              child.name?.includes(`[1][firstname]`),
                          )
                          .name.match(/^(.+)\[1\]/)[1]
                    : `children_guests[${uniQid}]`;
            acc.push(
                {
                    name: `${childPrefix}[${childIndex}][firstname]`,
                    value: guest.firstName,
                },
                {
                    name: `${childPrefix}[${childIndex}][lastname]`,
                    value: guest.lastName,
                },
                {
                    name: `${childPrefix}[${childIndex}][country_id]`,
                    value: getIndexCountries(guest.nationality),
                },
                {
                    name: `${childPrefix}[${childIndex}][birth]`,
                    value: moment(guest.birthDate).format("DD.MM.YYYY"),
                },
            );
            return acc;
        }, []);

    const babies = data.guests
        ?.filter((guest) => guest.guestBaby)
        .reduce((acc, guest, index) => {
            const babiesIndex = index + 1;

            const babiesPrefix =
                commentObject !== null &&
                commentObject?.babies !== null &&
                commentObject?.babies?.length > 0
                    ? commentObject.babies
                          .find((baby) => baby.name?.includes(`[1][firstname]`))
                          .name.match(/^(.+)\[1\]/)[1]
                    : `babies_guests[${uniQid}]`;
            acc.push(
                {
                    name: `${babiesPrefix}[${babiesIndex}][firstname]`,
                    value: guest.firstName,
                },
                {
                    name: `${babiesPrefix}[${babiesIndex}][lastname]`,
                    value: guest.lastName,
                },
                {
                    name: `${babiesPrefix}[${babiesIndex}][country_id]`,
                    value: getIndexCountries(guest.nationality),
                },
                {
                    name: `${babiesPrefix}[${babiesIndex}][birth]`,
                    value: moment(guest.birthDate).format("DD.MM.YYYY"),
                },
            );
            return acc;
        }, []);

    const infants = data.guests
        ?.filter((guest) => guest.guestInfant)
        .reduce((acc, guest, index) => {
            const infantIndex = index + 1;

            const infantPrefix =
                commentObject !== null &&
                commentObject?.infants !== null &&
                commentObject?.infants?.length > 0
                    ? commentObject.infants
                          .find((baby) => baby.name?.includes(`[1][firstname]`))
                          .name.match(/^(.+)\[1\]/)[1]
                    : `infant_guests[${uniQid}]`;
            acc.push(
                {
                    name: `${infantPrefix}[${infantIndex}][firstname]`,
                    value: guest.firstName,
                },
                {
                    name: `${infantPrefix}[${infantIndex}][lastname]`,
                    value: guest.lastName,
                },
                {
                    name: `${infantPrefix}[${infantIndex}][country_id]`,
                    value: getIndexCountries(guest.nationality),
                },
                {
                    name: `${infantPrefix}[${infantIndex}][birth]`,
                    value: moment(guest.birthDate).format("DD.MM.YYYY"),
                },
            );
            return acc;
        }, []);

    const comment = {
        adults,
        childrens,
        babies,
        infants,
        comment_text: commentObject?.comment_text ?? null,
    };

    return JSON.stringify(comment);
};

const fetchUniqId = async () => {
    try {
        const response = await axios.get(
            "/manager/data/reservations/get_uni_qid",
        );
        return response.data;
    } catch (error) {
        console.error("Error fetching", error);
        return "";
    }
};

const getIndexCountries = (nationality) => {
    return COUNTRIES.findIndex((country) => country === nationality);
};

const getChiefGuest = (commentObject) => {
    const chiefGuestField = commentObject?.adults?.find((adult) =>
        adult?.name?.includes("[chief_guest]"),
    );
    return parseInt(chiefGuestField ? chiefGuestField.value : null);
};
